import { Certification, EMPLOYMENT_TYPE, Experience, PreviousExperience } from "../../../../../domains/models/employee";
import { IData, IDesignation, IExperienceFormModel, PreviousExperienceModel } from "../types/experience.types";
import server from "../../../../../server";
import dayjs from "dayjs";


export function viewMapper(data: IData): IExperienceFormModel {
    const {experience} = data;
    return {
        current: {
            companyName: experience.companyName,
            designationId: experience.designationItem?.id,
            designationCode: experience.designationItem?.code,
            designationDisplayName: experience.designationItem?.displayName||'',
            employmentType: experience.employmentType,
            primarySkills: experience.primarySkills,
            secondarySkills: experience.secondarySkills,
        },
        previous: experience.previousExperiences?.map((item: PreviousExperience) => ({
            companyName: item.companyName,
            designationId: item.designationItem.id,
            designationCode: item.designationItem.code,
            designationDisplayName: item.designationItem.displayName||'',
            startDate: dayjs(item.duration.startDate, "YYYY-MM-DD"),
            endDate: dayjs(item.duration.endDate, "YYYY-MM-DD"),
            years: item.years,
            months: item.months,
            annualCTC: item.annualCTC,
            reasonForLeaving: item.reasonForLeaving,
        })),
    };
}

export function modelMapper(data: IExperienceFormModel): Experience {
   console.log('model mapper 123',data)
    return {
        companyName: data.current.companyName,
        designationItem: {
            id: data.current.designationId,
            code: data.current.designationCode,
            displayName: data.current.designationDisplayName,
        },
        employmentType: data.current.employmentType,
        primarySkills: data.current.primarySkills,
        secondarySkills: data.current.secondarySkills,
        previousExperiences: data.previous?.map((item: PreviousExperienceModel) => ({
            companyName: item.companyName,
            designationItem: {
                id: item.designationId,
                code: item.designationCode,
                displayName: item.designationDisplayName
            },
            duration: {
                startDate: item.startDate.format("YYYY-MM-DD"),
                endDate: item.endDate.format("YYYY-MM-DD"),
            },
            years: item.years,
            months: item.months,
            annualCTC: item.annualCTC,
            reasonForLeaving: item.reasonForLeaving,
        })),
    };
}

export async function fetchData(employeeId: string) {
    const experience: Experience = await server.employee.experience.get(employeeId);

    return {experience}
}

export async function fetchDesignations(): Promise<IDesignation[]> {
    const designations = await server.settings.designation.list();
    return designations.map((designation: any) => ({
        id: designation.id,
        code: designation.code,
        displayName: designation.displayName
    }));
}

export const initialData: IData = {
    experience: {
        companyName: '',
        designationItem: {
            id: '',
            code: '',
        },
        employmentType: '' as EMPLOYMENT_TYPE,
        primarySkills: [],
        secondarySkills: [],
        previousExperiences: [
            {
                companyName: '',
                designationItem: {
                    id: '',
                    code: '',
                    displayName: ''
                },
                duration: {
                    startDate: '',
                    endDate: '',
                },
                years: 0,
                months: 0,
                annualCTC: 0,
                reasonForLeaving: '',
            }
        ]
    }
}


export const initialModelData: IExperienceFormModel = {
    current: {
        companyName: '',
        designationId: '',
        designationCode: '',
        designationDisplayName: '',
        employmentType: '' as EMPLOYMENT_TYPE,
        primarySkills: [],
        secondarySkills: [],
    },
    previous: [{
        companyName: '',
        designationId: '',
        designationCode: '',
        designationDisplayName: '',
        startDate: dayjs('2010-5-10', "YYYY-MM-DD"),
        endDate: dayjs('2012-8-31', "YYYY-MM-DD"),
        years: 0,
        months: 0,
        annualCTC: 12,
        reasonForLeaving: '',
    }],
}
